import moment from "moment";

import { DEFAULT_DATE_TIME_FORMAT } from "./constant";

export const getCurrentDate = format => {
  const newDate = moment();

  if (!format) {
    return newDate.toISOString();
  }

  return newDate.format(format);
};

export const currentTimeStamp = () => {
  return moment().valueOf();
};

export const getMoment = value => {
  return moment(value);
};

export const changeDateFormat = (date, format) => {
  const momentDate = moment(date);

  if (format) {
    return momentDate.format(format);
  }

  return momentDate.format(DEFAULT_DATE_TIME_FORMAT);
};

export const convertTimestampToDate = (timestamp, format) => {
  const momentDate = moment(timestamp, "x");

  if (format) {
    return momentDate.format(format);
  }

  return momentDate.format(DEFAULT_DATE_TIME_FORMAT);
};
